export enum TransportType {
  sessionStorage = 10,
  sharedWorker = 20,
  broadcastChannel = 30,
}
